import { METHOD } from 'services/method'

export const API_PRIVACY_POLICY = {
    DETAIL: {
        api: '/v1/dashboard-admin/more-info/privacy-policy',
        method: METHOD.GET,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/more-info/privacy-policy',
        method: METHOD.PUT,
    },
}
